import LogoDark from '../assets/Logo_dark.svg';
import LogoLight from '../assets/Logo_light.svg';
import { forwardRef, HTMLChakraProps, ThemingProps, Image } from '@chakra-ui/react';

export interface CustomLogoProps extends HTMLChakraProps<'img'>, ThemingProps {}

export const Logo = forwardRef<CustomLogoProps, 'img'>((props, ref) => {
    const { size, variant, ...rest } = props;

    return (
        <Image
            zIndex={100}
            src={variant == 'light' ? LogoDark : LogoLight}
            height="60px"
            marginRight="2em"
            ref={ref}
            {...rest}
        />
    );
});
